import namespaceHelper from '@/shared/helpers/namespace-helper';
import { namespace, UptakeInsightsActions, UptakeInsightsMutations } from './types';
import { ServiceOrderActions } from '../service-order/types';
import UptakeInsightsService from '@/shared/services/UptakeInsightsService';
import Cloner from '@/shared/helpers/cloner';

const _actions = namespaceHelper.removeNamespace(namespace, UptakeInsightsActions);
const _mutations = namespaceHelper.removeNamespace(namespace, UptakeInsightsMutations);
const _serviceOrderActions = namespaceHelper.removeNamespace(namespace, ServiceOrderActions);

export default {
  async [_actions.SEARCH_UPTAKE_INSIGHTS]({ commit }, parameters) {
    const response = await UptakeInsightsService.searchUptakeInsights(parameters);
    const payload = response.data;
    const searchResults = Array.isArray(payload)
      ? payload
      : payload?.items || payload?.results || payload?.data || payload?.uptakeInsights || [];
    commit(_mutations.SET_UPTAKE_INSIGHTS_SEARCH_RESULTS, searchResults);
    return searchResults;
  },
  async [_actions.UPDATE_INSIGHT_STATUS](_, params) {
    await UptakeInsightsService.updateInsightStatus(params);
  },
  async [_actions.FETCH_UNIT_UPTAKE_INSIGHTS]({ commit }, unitId) {
    const response = await UptakeInsightsService.fetchUnitUptakeInsights(unitId);
    const results = response.data;
    commit(_mutations.SET_UNIT_UPTAKE_INSIGHTS, results);
  },
  async [_actions.ADD_UPTAKE_INSIGHTS_TO_SO]({ dispatch }, params) {
    const clonedJobs = Cloner.deepClone(params.jobs);
    const selectedJobs = clonedJobs.filter(job => job.isSelected);
    selectedJobs.forEach(job => {
      job.serviceOrderId = params.serviceOrderId;
      job.branchId = params.branchId;
    });
    var result = await UptakeInsightsService.addUptakeInsightsToSO(selectedJobs);
    await dispatch(
      _serviceOrderActions.SET_SERVICE_ORDER,
      { serviceOrder: result.data, _showDetails: false },
      { root: true }
    );
  }
};
